<template>
    <GlobalMessage />
    <MyDetails />
</template>

<script>
import { ref, computed } from 'vue';

import GlobalMessage from './GlobalMessage.vue';
import MyDetails from './MyDetails.vue';

import { set } from 'immutable';

export default {
    name: 'Settings',
    components: {
        GlobalMessage,
        MyDetails
    },
}
</script>

<style lang="scss" scoped>
</style>